import { render, staticRenderFns } from "./LoadingStep.vue?vue&type=template&id=f2c4528a&scoped=true"
import script from "./LoadingStep.vue?vue&type=script&lang=js"
export * from "./LoadingStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c4528a",
  null
  
)

export default component.exports